module.exports = __webpack_public_path__ + "media/images/article-types-doc-513694d0f0bd3c7a1da363dddfe2ab37.jpg";